import React from 'react';
import { ArrowLeftRight } from 'react-bootstrap-icons';
import CurrencyInput from '../../../../common/CurrencyInput';
import PercentageInput from '../../../../common/PercentageInput';
import useLocalization from '../../../../../hooks/useLocalization';
import { formatCurrency } from './helper';

const SellingTax = ({
  sellingTaxBreakdown = [],
  totalTax,
  totalTaxPercentage,
  pnl = 0,
  appreciatedValue = 0,
  onTotalTaxChange,
  onTotalTaxPercentageChange,
  isApartmentAbroad,
  isTaxCalculatedAutomatically,
  onAutoCalculateModeChange
}) => {
  const { translate } = useLocalization();
  return (
    <>
      <div className="mt-1 d-flex align-items-center">
        <div className="flex-grow-1">
          <h6 className="mid mb-0">{translate('expected_selling_tax')}:</h6>
        </div>
        {!isApartmentAbroad && (
          <div>
            <h6 className={`a tiny text-primary hover mb-0`} onClick={onAutoCalculateModeChange}>
              <ArrowLeftRight className="mx-1" />
              {isTaxCalculatedAutomatically ? translate('switch_to_manual_mode') : translate('switch_to_auto_mode')}
            </h6>
          </div>
        )}
      </div>
      <hr className="my-2" />
      <div className="px-2">
        {[
          { title: translate('asset_value_at_selling_month_and_year'), value: appreciatedValue },
          { title: translate('profit'), value: pnl }
        ].map(({ title, value }) => (
          <h6 key={title} className="smallFont text-muted text-end">
            {title}: <span className="text-dark">{formatCurrency(value)}</span>
          </h6>
        ))}

        {sellingTaxBreakdown?.map(t => (
          <div>
            <h6 className="mb-0  smallFont text-dark text-end">
              {translate('upto')} {formatCurrency(t.to)}(<span>{t.percentage}%</span>)
            </h6>

            <h6 className="text-end text-muted smallFont mt-2">
              <b>={formatCurrency(t.actualTax)}</b>
            </h6>
          </div>
        ))}

        <div className="smallFont mb-3 d-flex">
          <div className={isApartmentAbroad ? 'w-50' : 'w-100'}>
            <b>{translate('tax_total')}: </b>
            <CurrencyInput
              size="sm"
              disabled={!isApartmentAbroad && isTaxCalculatedAutomatically}
              onChange={value => onTotalTaxChange(value)}
              value={totalTax}
              maxDecimal={0}
            />
          </div>
          {isApartmentAbroad && (
            <div className="mx-2 w-50">
              <b>{translate('tax_percent')}: </b>
              <PercentageInput
                size="sm"
                onChange={value => onTotalTaxPercentageChange(value)}
                value={totalTaxPercentage}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SellingTax;
